import React from "react";

const GroupItem = ({ text }) => {
  if (typeof text !== "string") {
    return text;
  }

  if (!text.includes("観測") && !text.includes("予測")) {
    return text;
  }

  const parts = text.split(/(観測|予測)/g);

  return (
    <>
      {parts.map((part, index) => {
        if (part === "観測") {
          return <span className="o" key={`o-${index}`}>{part}</span>;
        }
        if (part === "予測") {
          return <span className="p" key={`p-${index}`}>{part}</span>;
        }
        return <React.Fragment key={`t-${index}`}>{part}</React.Fragment>;
      })}
    </>
  );
};

export default GroupItem;